import React from "react";
import { useParams } from "react-router";
import { useAppSelector } from "../../hooks";
import { Article } from "../../store/actions/types";
import { RouterState } from "../Grid";

// Components
import RelatedArticle from "./RelatedArticle";

import * as S from "./style";

interface RelatedProps {
  title?: string;
  items: Article[];
}

const Related: React.FC<RelatedProps> = ({ title, items }) => {
  const { author } = useParams<RouterState>();
  const { total_articles } = useAppSelector((state) => state.articles.data);
  const relatedArticles: Article[] = [];

  if (!author) {
    total_articles.filter((article) => {
      items.map((item) => {
        if (article["@id"] === item["@id"]) {
          return relatedArticles.push(article);
        }

        return [];
      });

      return [];
    });
  }

  return (
    <>
      {items.length > 0 && (
        <>
          <S.RelatedTitle>
            {title || "Potrebbero interessarti..."}
          </S.RelatedTitle>
          <S.Related>
            {items.slice(0, 3).map((item: Article, i) => {
              return item !== null ? (
                <RelatedArticle
                  key={`${items[i]["@id"]}-${i}`}
                  id={items[i]["@id"]}
                  effective={item.effective}
                  title={item.title}
                  subjects={
                    item.subjects
                      ? [...new Set(item.subjects.concat(item.Subject || []))]
                      : item.Subject
                  }
                  parent={item.parent}
                />
              ) : null;
            })}
          </S.Related>
        </>
      )}
    </>
  );
};

export default Related;
